import { render, staticRenderFns } from "./top.vue?vue&type=template&id=69e9894e&scoped=true"
var script = {}
import style0 from "./top.vue?vue&type=style&index=0&id=69e9894e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e9894e",
  null
  
)

export default component.exports